import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  isApplicantSelector,
  isCorpClientSelector,
  isEYProSelector,
  isEYAdminSelector,
  isEyEngagementAdminSelector,
  isCorporateClientLineManagerSelector,
  isRestrictedCorpMemberSelector,
} from 'src/ui/features/Login/state/loginReselect';
import CollapsibleMenu from './CollapsibleMenu';
import { trackClickAnalytics } from 'src/helpers/adobeUtils';
import { setSelectedMenuType } from 'src/ui/features/Dashboard/state/dashboardActions';
import { getUnreadMessageCount } from '../../../services/dashboard.service';
import { refreshUnReadMessage } from 'src/new-ui/features/NewDashboard/state/newDashboardAction.js';
import { fnRefreshDashboardUnReadCount } from 'src/ui/features/Messaging/state/messagingActions.js';
class CollapsibleMenuContainer extends Component {
  state = {
    isMenuOpen: false,
    messageCount: 0,
  };

  async componentDidMount() {
    await this.fetchUnreadMessageCount();
  }
  fetchUnreadMessageCount = async () => {
    const count = await getUnreadMessageCount();
    this.setState({ messageCount: count });
  };
  async componentDidUpdate() {
    if (this.props.refreshMessageCount && this.props.refreshDashboardUnReadCount) {
      await this.fetchUnreadMessageCount();
      this.props.refreshUnReadMessage(false);
      this.props.fnRefreshDashboardUnReadCount();
    }
  }
  toggleDrawer = (open, flag) => () => {
    if (flag) {
      this.props.setSelectedMenuType(flag);
    }
    this.setState({ isMenuOpen: open });
  };

  render() {
    return (
      <CollapsibleMenu
        userInfo={this.props.userInfo}
        isEYPro={this.props.isEYPro}
        isEYAdmin={this.props.isEYAdmin}
        isApplicant={this.props.isApplicant}
        isCorpClient={this.props.isCorpClient}
        isRestrictedCorpMember={this.props.isRestrictedCorpMember}
        isEyEngagementAdmin={this.props.isEyEngagementAdmin}
        isCorporateClientLineManager={this.props.isCorporateClientLineManager}
        countInboxUnread={this.props.countInboxUnread}
        countIncompleteTasks={this.props.countIncompleteTasks}
        isMenuOpen={this.state.isMenuOpen}
        toggleDrawer={this.toggleDrawer}
        trackClickAnalytics={trackClickAnalytics}
        isAllData={this.props.isAllData}
        showPrivacy={this.props.showPrivacy}
        showTou={this.props.showTou}
        messageCount={this.state.messageCount}
        fetchUnreadMessageCount={this.fetchUnreadMessageCount}
      />
    );
  }
}

// export default CollapsibleMenuContainer;
const mapStateToProps = state => {
  let countInboxUnread = state.dashboard.headerCount ? state.dashboard.headerCount.countNewMessages : 0;
  if (state.messaging.countInboxUnread != null && state.messaging.countInboxUnread < countInboxUnread) {
    countInboxUnread = state.messaging.countInboxUnread;
  }

  return {
    userInfo: state.login,
    countInboxUnread,
    countIncompleteTasks: state.dashboard.headerCount ? state.dashboard.headerCount.countIncompleteTasks : 0,
    isEYPro: isEYProSelector(state),
    isEYAdmin: isEYAdminSelector(state),
    isApplicant: isApplicantSelector(state),
    isCorpClient: isCorpClientSelector(state),
    isEyEngagementAdmin: isEyEngagementAdminSelector(state),
    isCorporateClientLineManager: isCorporateClientLineManagerSelector(state),
    isCorporateClientLineManagerSelector: isCorporateClientLineManagerSelector(state),
    isRestrictedCorpMember: isRestrictedCorpMemberSelector(state),
    isAllData: state.dashboard.dashboardType === 'allData',
    refreshMessageCount: state.newDashboard.refreshMessageCount,
    refreshDashboardUnReadCount: state.messaging.refreshDashboardUnReadCount,
  };
};

const mapDispatchToProps = {
  setSelectedMenuType,
  refreshUnReadMessage,
  fnRefreshDashboardUnReadCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollapsibleMenuContainer);
